import React from "react";
import styled from "@emotion/styled";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import EnterCode from "./EnterCode";
import ResendVerification from "./ResendVerification";
import VerificationComplete from "./VerificationComplete";
import SetupVerificationMethod from "./SetupVerificationMethod";
import { closeModal } from "./action";
import { message } from "../Messages/selector";
import { currentFlowStage } from "./selector";
import {
  HIDE_LOADING,
  SHOW_TWILIO_POPUP,
  RESET_SELL
} from "@constants/actionTypes";
import { defaultAction } from "@actions/defaultAction";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const InnerContainer = styled.div`
  max-width: 80%;
  margin: 0 auto;
  min-height: 350px;
  padding-top: ${props => props.setPadding};
  padding-bottom: 40px;
  position: relative;

  @media (max-width: 600px) {
    max-width: 85%;
  }
  @media (max-width: 350px) {
    min-height: 330px;
  }
`;

const FailedToVerify = styled.div`
  padding-bottom: 20px;
`;

const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 25px;
  min-height: 261px;
`;

const FailedHeader = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  width: fit-content;
  margin: 0 auto;
  margin-top: -28px;
`;

const FailedP = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: #777984;
  max-width: 275px;
  margin: 0 auto;
  margin-top: 21px;
  margin-bottom: 50px;
`;

const FailedImg = styled.img`
  width: 250px;
  height: auto;
`;

const OrderVerificationMain = ({
  orderUUID,
  type,
  closable,
  page,
  activeSellOrder
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const theCurrentFlowStage = useSelector(state => currentFlowStage(state));
  const theMessage = useSelector(state => message(state));

  return (
    <InnerContainer setPadding={closable ? "0px" : "44px"}>
      {theMessage ? (
        <FailedToVerify className="failed-container">
          <ImgContainer>
            <FailedImg
              src="https://cdn.cardcash.com/website/ui/elements/error-icon-large.svg"
              alt="error"
            />
          </ImgContainer>
          <FailedHeader>{theMessage.title}</FailedHeader>
          <FailedP>{theMessage.content}</FailedP>
          <DefaultOrangeButton
            handleClick={() => {
              if (page) {
                history.push("/");
              } else {
                dispatch(closeModal());
                dispatch(defaultAction(HIDE_LOADING));
              }
              if (activeSellOrder) {
                dispatch(defaultAction(SHOW_TWILIO_POPUP, false));
                dispatch(defaultAction(RESET_SELL));
                history.push("/account/sell/");
              }
            }}
            classes={"main-default-orange-button"}
          >
            <span>Close</span>
          </DefaultOrangeButton>
        </FailedToVerify>
      ) : (
        <div>
          {theCurrentFlowStage === "select-phone" && (
            <SetupVerificationMethod
              type={type}
              orderUUID={orderUUID}
              closable={closable}
              page={page}
            />
          )}
          {theCurrentFlowStage === "enter-code" && (
            <EnterCode type={type} orderUUID={orderUUID} />
          )}
          {theCurrentFlowStage === "buy-done" && (
            <ResendVerification type={type} orderUUID={orderUUID} />
          )}
          {theCurrentFlowStage === "done" && (
            <VerificationComplete closable={closable} page={page} />
          )}
        </div>
      )}
    </InnerContainer>
  );
};

export default OrderVerificationMain;
